import React, {
    useContext,
    useState
} from 'react';

import '../styles/CreatePosts.css';

import {
    GeneralContext
} from '../context/GeneralContextProvider';

import {
    RxCross2
} from 'react-icons/rx';


const CreateStory = () => {

    const {
        socket,
        isCreateStoryOpen,
        setIsCreateStoryOpen
    } = useContext(GeneralContext);


    const [storyType, setStoryType] =
        useState('photo');

    const [storyDescription, setStoryDescription] =
        useState('');

    const [storyFile, setStoryFile] =
        useState(null);

    const [uploadProgress, setUploadProgress] =
        useState();


    const handleStoryUpload = async (e) => {

        e.preventDefault();


        if (!storyFile) {

            alert(
                "Please select a photo or video"
            );

            return;
        }


        try {

            setUploadProgress(1);


            // =========================
            // CLOUDINARY UPLOAD
            // =========================
            const formData = new FormData();

            formData.append(
                "file",
                storyFile
            );

            formData.append(
                "upload_preset",
                "socialex_upload"
            );


            const resourceType =
                storyType === "video"
                    ? "video"
                    : "image";


            const response = await fetch(
                `https://api.cloudinary.com/v1_1/ktdod8i6/${resourceType}/upload`,
                {
                    method: "POST",
                    body: formData
                }
            );


            const data =
                await response.json();


            if (!response.ok) {

                throw new Error(
                    data.error?.message ||
                    "Cloudinary upload failed"
                );

            }


            const downloadURL =
                data.secure_url;


            console.log(
                "File uploaded to Cloudinary:",
                downloadURL
            );


            // =========================
            // SEND STORY TO SERVER
            // =========================
            socket.emit(
                'create-new-story',
                {
                    userId:
                        localStorage.getItem(
                            'userId'
                        ),

                    username:
                        localStorage.getItem(
                            'username'
                        ),

                    userPic:
                        localStorage.getItem(
                            'profilePic'
                        ),

                    fileType:
                        storyType,

                    file:
                        downloadURL,

                    text:
                        storyDescription
                }
            );


            // =========================
            // RESET UI
            // =========================
            setIsCreateStoryOpen(false);

            setStoryDescription('');

            setStoryFile(null);

            setUploadProgress(undefined);


        } catch (error) {

            console.error(
                "Story upload failed:",
                error
            );


            alert(
                "Story upload failed. Please try again."
            );


            setUploadProgress(undefined);

        }

    };


    return (

        <div
            className="createPostModalBg"
            style={
                isCreateStoryOpen
                    ? {
                        display: 'contents'
                    }
                    : {
                        display: 'none'
                    }
            }
        >

            <div className="createPostContainer">

                <RxCross2
                    className='closeCreatePost'
                    onClick={() =>
                        setIsCreateStoryOpen(false)
                    }
                />


                <h2 className="createPostTitle">
                    Add new story
                </h2>


                <hr className="createPostHr" />


                <div className="createPostBody">

                    <form>

                        <select
                            className="form-select"
                            aria-label="Select Story Type"
                            value={storyType}
                            onChange={(e) =>
                                setStoryType(
                                    e.target.value
                                )
                            }
                        >

                            <option value="photo">
                                Photo
                            </option>

                            <option value="video">
                                Video
                            </option>

                        </select>


                        <div className="uploadBox">

                            <input
                                type="file"
                                name="StoryFile"
                                id="uploadStoryFile"

                                accept={
                                    storyType === "video"
                                        ? "video/*"
                                        : "image/*"
                                }

                                onChange={(e) =>
                                    setStoryFile(
                                        e.target.files[0]
                                    )
                                }
                            />

                        </div>


                        <div className="form-floating mb-3 authFormInputs descriptionInput">

                            <input
                                type="text"
                                className="form-control descriptionInput"
                                id="floatingDescription"
                                placeholder="Description"

                                onChange={(e) =>
                                    setStoryDescription(
                                        e.target.value
                                    )
                                }

                                value={
                                    storyDescription
                                }
                            />

                            <label
                                htmlFor="floatingDescription"
                            >
                                Text
                            </label>

                        </div>


                        {uploadProgress !== undefined ? (

                            <button disabled>
                                Uploading...
                                {' '}
                                {Math.round(
                                    uploadProgress
                                )}
                                %
                            </button>

                        ) : (

                            <button
                                type="button"
                                onClick={
                                    handleStoryUpload
                                }
                            >
                                Upload
                            </button>

                        )}

                    </form>

                </div>

            </div>

        </div>

    );
};


export default CreateStory;
